import { IOfferReaction } from '../../repositories/cian-chat-bot/entities/offer_reaction/OfferReaction';
import {
  fetchPublicMobileV1SetOfferReaction,
  TPublicMobileV1SetOfferReactionResponse,
} from '../../repositories/cian-chat-bot/mobile/v1/set-offer-reaction';
import { TContext } from '../../types/context';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

type TChatbotSetOfferReactionContext = Pick<TContext, 'httpApi' | 'logger'>;

const DEFAULT_ERROR_MESSAGE = 'Ошибка при сохранении лайка/дизлайка чатбота';

export async function chatbotSetOfferReaction(
  { httpApi, logger }: TChatbotSetOfferReactionContext,
  parameters: IOfferReaction,
): Promise<boolean> {
  try {
    const { response, statusCode }: TPublicMobileV1SetOfferReactionResponse = await fetchPublicMobileV1SetOfferReaction(
      {
        httpApi,
        parameters,
      },
    );

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return true;
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/mobile/v1/set-offer-reaction/',
      parameters: JSON.stringify(parameters),
    });

    return false;
  }
}
